var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo } from 'react';
import { Select } from '@folio/stripes/components';
import { Field } from 'react-final-form';
import { useIntl } from 'react-intl';
import { HeaderFooterTokenType } from '../../../types';
export default function HeaderFooterTypeSelect(_a) {
    var name = _a.name;
    var intl = useIntl();
    var options = useMemo(function () {
        var topSection = [
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.newline',
                }),
                value: HeaderFooterTokenType.NEWLINE,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.newlineMicrosoft',
                }),
                value: HeaderFooterTokenType.NEWLINE_MICROSOFT,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.tab',
                }),
                value: HeaderFooterTokenType.TAB,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.comma',
                }),
                value: HeaderFooterTokenType.COMMA,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.whitespace',
                }),
                value: HeaderFooterTokenType.SPACE,
            },
        ];
        var bottomSection = [
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.arbitraryText',
                }),
                value: HeaderFooterTokenType.ARBITRARY_TEXT,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.currentDate',
                }),
                value: HeaderFooterTokenType.CURRENT_DATE,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.numAccounts',
                }),
                value: HeaderFooterTokenType.AGGREGATE_COUNT,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.totalAmount',
                }),
                value: HeaderFooterTokenType.AGGREGATE_TOTAL,
            },
        ];
        topSection.sort(function (a, b) { return a.label.localeCompare(b.label); });
        bottomSection.sort(function (a, b) { return a.label.localeCompare(b.label); });
        return __spreadArray(__spreadArray(__spreadArray([], topSection, true), [
            {
                label: '',
                value: HeaderFooterTokenType.NEWLINE,
                disabled: true,
            }
        ], false), bottomSection, true);
    }, [intl]);
    return (React.createElement(Field, { name: name, defaultValue: HeaderFooterTokenType.NEWLINE, "aria-label": intl.formatMessage({
            id: 'ui-plugin-bursar-export.bursarExports.token.headerFooter.typeSelect',
        }) }, function (fieldProps) { return React.createElement(Select, __assign({}, fieldProps, { required: true, marginBottom0: true, dataOptions: options })); }));
}
